import { ADD_CART, DELETE_CART, FETCH_CARTS, UPDATE_CART, UPDATE_CART_LOCAL, SET_ACTIVE_CART, SET_CART_ORDERS, SET_NEXT_PICK_ITEM, SET_TOTE_ASSIGNMENTS, SET_UNSCANNED_ITEMS, SET_IS_CART_VIEW, SET_PICKING_SESSION, SET_IS_NOT_EMPTY_CART, SET_CART_ASSIGNMENT_DETAILS, SET_CART_ASSIGNMENT_TOAST, SET_CART_ASSIGNMENT_DETAILS_PROMPT, SET_ZONE_ACCESS_MODAL_FOR_CART, SET_NON_ASSIGNMENT_DETAILS, SET_PREVIOUS_NEXT_PICK_ITEMS, SET_CURRENT_CART_SCAN_COMPLETE, SET_SCANNED_ITEMS, SET_NOT_FULL_FILLED_ITEMS, SET_PREVIOUS_SCAN_INFO, SET_RFO_NO_ORDERS, SET_SHOW_CART_READY_BANNER, SET_OUT_OF_STOCK_PROMPT, SET_CART_TOAST_MESSAGE } from "../constants";

const initialState = {
  carts: [],
  activeCart: null,
  cartOrders: [],
  toteAssignments: [],
  unScannedItems: [],
  scannedItems:[],
  nextPickItem: null,
  isCartView: false,
  loading: false,
  hasActivePickingErrorMessage: null,
  hasActivePickingSession: false, // cart have scanning in progress
  pickingSessionData: null,//current scanning cart data in progress
  error: null,
  isNotEmptyCart: false,
  cartAssignmentDetails: {
    notAssignedOrders:[],
    assignedOrders:[],
  },
  notAssignmentOrderDetails: null,
  showCartAssignmentToast: false,
  showCartAssignmentDetailsPrompt: false,
  zoneAccessModalForCart: { visible: false, cartId: null, cartName: null },
  previousNextPickItems: [],
  currentCartScanComplete: {
    isVisible: false,
    messageKey: "scanToCart.scanningCompleted",
    showCloseIcon: false,
    celebrate: true,
  },
  notFullFilledItems: [],
  previousScanInfo: null,
  isRfoNoOrders: false,
  showCartReadyBanner: false,
  showOutOfStockPrompt: false,
  cartToastMessage: null,
  cartToastOptions: null,
};

export default function scanToCartReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CART_LOCAL:
      return {
        ...state,
        carts: state.carts.map(cart => 
          cart.id === action.payload.id ? action.payload : cart
        )
      };

    case ADD_CART:
      return {
        ...state,
        carts: [...state.carts, action.payload],
        loading: false,
        error: null
      };
    case UPDATE_CART:
      return {
        ...state,
        carts: state.carts.map(cart => {
          if (cart.id === action.payload.id) {
            return action.payload;
          }
          return cart;
        }),
        loading: false,
        error: null
      };
    case DELETE_CART:
      return {
        ...state,
        carts: state.carts.filter(cart => cart.id !== action.payload),
        loading: false,
        error: null
      };
    case FETCH_CARTS:
      return {
        ...state,
        carts: action.payload,
        loading: false,
        error: null
      };
    case SET_ACTIVE_CART:
      return {
        ...state,
        activeCart: action.payload,
        showCartReadyBanner:
          state.showCartReadyBanner &&
          !(
            state.activeCart &&
            action.payload &&
            action.payload.cart_id !== state.activeCart.cart_id
          )
      };
    case SET_CART_ORDERS:
      return {
        ...state,
        cartOrders: action.payload
      };
    case SET_NEXT_PICK_ITEM:
      return {
        ...state,
        nextPickItem: action.payload
      };
    case SET_TOTE_ASSIGNMENTS:
      return {
        ...state,
        toteAssignments: action.payload
      };
    case SET_UNSCANNED_ITEMS:
      return {
        ...state,
        unScannedItems: action.payload
      };
    case SET_SCANNED_ITEMS:
      return {
        ...state,
        scannedItems: action.payload
      };
    case SET_IS_CART_VIEW:
      return {
        ...state,
        isCartView: action.payload
      };
    case SET_PICKING_SESSION:
      return {
        ...state,
        hasActivePickingErrorMessage: action.payload.errorMessage,
        hasActivePickingSession: action.payload.isInProgress,
        pickingSessionData: action.payload.data
      };
    case SET_IS_NOT_EMPTY_CART:
      return {
        ...state,
        isNotEmptyCart: action.payload,
      };
    case SET_CART_ASSIGNMENT_DETAILS:
      return {
        ...state,
        cartAssignmentDetails: action.payload,
      };
    case SET_CART_ASSIGNMENT_TOAST:
      return {
        ...state,
        showCartAssignmentToast: action.payload,
      };
    case SET_CART_ASSIGNMENT_DETAILS_PROMPT:
      return {
        ...state,
        showCartAssignmentDetailsPrompt: action.payload,
      };
    case SET_ZONE_ACCESS_MODAL_FOR_CART:
      return {
        ...state,
        zoneAccessModalForCart: action.payload,
      };
    case SET_NON_ASSIGNMENT_DETAILS:
      return {
        ...state,
        notAssignmentOrderDetails: action.payload,
      };
    case SET_PREVIOUS_NEXT_PICK_ITEMS:
      return {
        ...state,
        previousNextPickItems: action.payload,
      };
    case SET_CURRENT_CART_SCAN_COMPLETE:
      return {
        ...state,
        currentCartScanComplete: action.payload,
      };
    case SET_NOT_FULL_FILLED_ITEMS:
      return {
        ...state,
        notFullFilledItems: action.payload,
      };
    case SET_PREVIOUS_SCAN_INFO:
      return {
        ...state,
        previousScanInfo: action.payload,
      };
    case SET_RFO_NO_ORDERS:
      return {
        ...state,
        isRfoNoOrders: action.payload,
      };
    case SET_SHOW_CART_READY_BANNER:
      return {
        ...state,
        showCartReadyBanner: action.payload,
      };
    case SET_OUT_OF_STOCK_PROMPT:
      return {
        ...state,
        showOutOfStockPrompt: action.payload,
      };
    case SET_CART_TOAST_MESSAGE:
      return {
        ...state,
        cartToastMessage: action.payload,
        cartToastOptions: action.payload ? action.options || null : null,
      };
    default:
      return state;
  }
}
